module.exports = __webpack_public_path__ + "static/FL4-b20f785701a1e0a76a25fcbde6e500e1.jpg";